import React from "react";
import { FieldsListBox } from "../../containers";

export const FieldsPage = () => {
  return (
    <div>
      <FieldsListBox />
    </div>
  );
};
